(function () {
    const header = document.querySelector('.gh-header.has-background-image');
    const services = document.querySelector('.gh-podcast-service-list');
    if (!header || !services) return;

    header.style.setProperty('--services-height', `${services.offsetHeight}px`);
})();

(function () {
    pagination(true);
})();

var carousel = document.querySelector('.carousel');
var items = carousel.querySelectorAll('.carousel-item');
var controls = document.createElement('div');
controls.classList.add('carousel-controls');
controls.innerHTML = '<span class="carousel-control prev">❮</span><span class="carousel-control next">❯</span>';
carousel.appendChild(controls);

var current = 0;
items[current].classList.add('active');

var next = 1;
var interval = setInterval(function() {
items[current].classList.remove('active');
items[next].classList.add('active');
current = next;
next = current + 1;
if (next >= items.length) {
next = 0;
}
}, 10000);

var prevBtn = controls.querySelector('.prev');
var nextBtn = controls.querySelector('.next');
prevBtn.addEventListener('click', function() {
clearInterval(interval);
items[current].classList.remove('active');
current--;
if (current < 0) {
current = items.length - 1;
}
items[current].classList.add('active');
next = current + 1;
if (next >= items.length) {
next = 0;
}
interval = setInterval(function() {
items[current].classList.remove('active');
items[next].classList.add('active');
current = next;
next = current + 1;
if (next >= items.length) {
next = 0;
}
}, 10000);
});

nextBtn.addEventListener('click', function() {
clearInterval(interval);
items[current].classList.remove('active');
current++;
if (current >= items.length) {
  current = 0;
}
items[current].classList.add('active');
next = current + 1;
if (next >= items.length) {
next = 0;
}
interval = setInterval(function() {
items[current].classList.remove('active');
items[next].classList.add('active');
current = next;
next = current + 1;
if (next >= items.length) {
  next = 0;
  }
  }, 10000);
  });